import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { AsOfDateComponent } from './as-of-date.component';
import { DatepickerModule } from 'app/components/shared/datepicker/datepicker.module';

@NgModule({
    imports: [
        SharedModule,
        DatepickerModule,
    ],
    declarations: [AsOfDateComponent],
    exports: [AsOfDateComponent],
})
export class AsOfDateModule
{
}
